import { StandardEvents } from '@shopify/events';

class OvdvPriceRequest extends HTMLElement {
  connectedCallback() {
    this.eventTarget = this.closest('.shopify-section, dialog');
    this.eventTarget?.addEventListener(StandardEvents.productSelect, this.handleProductSelect);
  }

  disconnectedCallback() {
    this.eventTarget?.removeEventListener(StandardEvents.productSelect, this.handleProductSelect);
  }

  handleProductSelect = (event) => {
    const sourceCard = event.target instanceof Element ? event.target.closest('product-card') : null;
    if (sourceCard && !sourceCard.contains(this)) return;

    event.promise
      .then(({ detail }) => {
        if (!detail) return;

        if (detail.newProduct) {
          this.dataset.productId = detail.newProduct.id;
        } else if (detail.productId && detail.productId !== this.dataset.productId) {
          return;
        }

        const updatedComponent = Array.from(detail.html?.querySelectorAll('ovdv-price-request') || []).find(
          (component) => component instanceof HTMLElement && component.dataset.blockId === this.dataset.blockId
        );
        const updatedActions = updatedComponent?.querySelector('[data-ovdv-request-actions]');
        const currentActions = this.querySelector('[data-ovdv-request-actions]');

        if (updatedComponent instanceof HTMLElement) {
          this.dataset.requestVariantIds = updatedComponent.dataset.requestVariantIds || '';
        }
        if (updatedActions && currentActions) {
          currentActions.replaceWith(updatedActions.cloneNode(true));
        }

        this.setRequestState(detail.resource?.id);
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[OVDV price request] Product selection failed:', error);
      });
  };

  setRequestState(variantId) {
    const requestVariantIds = (this.dataset.requestVariantIds || '')
      .split(',')
      .map((id) => id.trim())
      .filter(Boolean);
    this.dataset.requestActive = String(requestVariantIds.includes(String(variantId || '')));
  }
}

if (!customElements.get('ovdv-price-request')) {
  customElements.define('ovdv-price-request', OvdvPriceRequest);
}
